var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',_vm._g(_vm._b({staticClass:"pagination",attrs:{"background":""}},'el-pagination',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }